<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Manage</a></li>
          <li><a>Requests</a></li>
          <li><a>Topics</a></li>
        </ul>
      </div>
      <div class="block">
        <div class="page-header">
          <span class="page-header__title">Request Topics</span>
          <img src="assets/images/New_Icons/refresh-icon.svg" alt="Refresh icon" title="Refresh" class="page-header__icon" width="17" height="17" (click)="!enableDisablePageLoader ? ngOnInit() : null"/>
        </div>
        <div class="list_block">
          <div class="toolbar">
            <div class="toolbar__search">
              <img src="../../../../../../assets/images/New_Icons/search-icon.svg" alt="Search icon">
              <input type="text" (ngModelChange)="onSearchChanged()" [(ngModel)]="search" name="search" autocomplete="off" placeholder="Search by service request topic"/>
            </div>
            <div class="toolbar__spacer"></div>
            <div class="toolbar__add-button" (click)="openForm()">
              <button type="button">
                <span class="toolbar__add-icon">
                  <img src="../../../../../../assets/images/New_Icons/plus-icon.svg" alt="Add Icon"/>
                </span>
                <span class="toolbar__add-text">Add New</span>
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="enableDisablePageLoader">
          <div class="adjust">
            <div class="loader2"></div>
          </div>
        </div>
        <div class="cards_container" *ngIf="!enableDisablePageLoader">
          <div class="card_wrapper" *ngFor="let srtopic of srTopicsList; let i = index">
            <div class="master-card">
              <div class="master-card-header">
                <div class="master-card-title">
                  <img src="../../../../../../assets/images/New_Icons/card-heading.svg" alt="Left arrow icon">
                  <span>{{ srtopic && srtopic.name }}</span>
                </div>
              </div>
              <div class="master-card-body">
                <div class="master-card-body-info">
                  <span class="card-content-text">Description:</span>
                  <span class="text">{{ srtopic?.description || 'NA' }}</span>
                </div>
                <div class="master-card-body-info">
                  <span class="card-content-text">Created At:</span>
                  <span class="text">{{ srtopic?.createdAt | date: "dd MMM yyyy" }}</span>
                </div>
              </div>
              <div class="master-card-footer">
                <div class="master-card-footer-info">
                  <span class="label">Updated At:</span>
                  <span class="text">{{ srtopic?.updatedAt | date: "dd MMM yyyy" }}</span>
                </div>
                <div class="action-icons">
                  <a>
                    <img src="../../../../../../assets/images/New_Icons/edit.svg" alt="Edit icon" title="Edit Topic" (click)="getSrTopicById(srtopic.id)">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="listLoader" class="loader-div">
          <div class="adjust">
            <div class="loader2 list-loader"></div>
          </div>
        </div>
        <div *ngIf="noList && !enableDisablePageLoader" class="noDataFoundMessage">Service Request Topics Not Found</div>
      </div>

      <!--add/update form-->
      <div class="dynamic-form-wrapper" [ngClass]="{ 'floating-panel': formFieldCount <= 7, 'slide-in-overlay': formFieldCount > 7}" *ngIf="showForm">
        <div class="popup-wrapper">
          <button type="button" class="popup-close-beside" (click)="clear()" title="Close">&times;</button>
          <!-- Actual Popup -->
          <div [ngClass]="{ 'form-container-panel': formFieldCount > 7, 'popup-inner': formFieldCount <= 7}">
            <form [formGroup]="registerForm" novalidate>
              <div class="form-header">
                <div class="form-title">Service Request</div>
                <button type="button" class="add-update-submit-button" (click)="addUpdateSrTopic()" [disabled]="srTopicsDoubleClick">
                  <span class="icon"><img src="../../../../../../assets/images/New_Icons/tick-icon.svg" alt="Tick icon"></span>
                  <span class="text">{{ submitButton ? 'Submit' : 'Update' }}</span>
                </button>
              </div>
              <div class="form-container">
                <!-- Topic Name -->
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Name</mat-label>
                  <input matInput id="topicName" type="text" formControlName="name" autocomplete="off" placeholder="Enter topic name"/>
                  <mat-hint><i>2–30 characters</i></mat-hint>
                  <mat-error *ngIf="(f.name.dirty || f.name.touched || submitted) && f.name.errors">
                    <i>{{ f.name.hasError('required') ? 'Name is required.' : f.name.hasError('minlength') ? 'Minimum 2 characters required.' : f.name.hasError('maxlength') ? 'Maximum 30 characters allowed.' : '' }}</i>
                  </mat-error>
                </mat-form-field>
                <!-- Description -->
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Description</mat-label>
                  <textarea matInput id="description" rows="3" formControlName="description" autocomplete="off" placeholder="Enter description"></textarea>
                  <mat-hint><i>Maximum 50 characters</i></mat-hint>
                  <mat-error *ngIf="(f.description.dirty || f.description.touched || submitted) && f.description.errors">
                    <i>{{ f.description.hasError('required') ? 'Description is required.' : f.description.hasError('maxlength') ? 'Maximum 50 characters allowed.' : '' }}</i>
                  </mat-error>
                </mat-form-field>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!--add/update form end-->
    </div>
  </div>
</div>

